// Matches lendcord-core's field constraints for POST /profile, PUT
// /profile/addresses/{type}, and PUT /profile/bank-details/primary (see the
// Postman collection's Profile folder).

export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const AADHAAR_REGEX = /^[0-9]{12}$/;
export const PINCODE_REGEX = /^[0-9]{6}$/;
export const ACCOUNT_NUMBER_REGEX = /^[0-9]{9,18}$/;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export const MIN_AGE_YEARS = 18;

export function isAtLeast18(dob: string): boolean {
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - MIN_AGE_YEARS);
  return new Date(dob) <= eighteenYearsAgo;
}
